import React, { useState } from "react";
import InsideIndia from "./InsideIndia";
import OutSideIndia from "./OutSideIndia";
import Gericare from "./Gericare";
import Style from "./PrivacyPolicy.module.scss";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
function PrivacyPolicy() {
  const [insideIndia, setTerms] = useState(true);
  const clientDetails = JSON.parse(localStorage.getItem("ClinicDetails"));
  const [isgericare, setIsgericares] = useState(clientDetails!=undefined && clientDetails.clinicurl==="gericare"?true:false);
  return (
    <Container>
      <div className={Style.PrivacyPolicy_main}>
        <div className={Style.btn_wrapper}>
          {isgericare?null
          :<>
          <Button
            variant="secondary"
            className={`${Style.btn_1} ${insideIndia ? Style.active_btn1 : ""}`}
            onClick={() => setTerms(true)}
          >
            For patients from India
          </Button>
          <Button
            variant="secondary"
            className={`${Style.btn_1} ${
              !insideIndia ? Style.active_btn1 : ""
            }`}
            onClick={() => setTerms(false)}
          >
            Rest of the World
          </Button>
          </>
          } 
        </div>
        {isgericare?<Gericare/>:
        insideIndia ? <InsideIndia /> : <OutSideIndia />}
      </div>
    </Container>
  );
}

export default PrivacyPolicy;
